export enum SocialPlatform {
  APPLE = "SignInWithApple",
  GOOGLE = "Google",
  FACEBOOK = "Facebook",
}
